<template>
	<div class="container-fluid">	
		<h4 class="text-center">{{datasets.length}} datasets</h4>
		<div class="list-group">
			<div class="list-group-item" v-for="gse in datasets">
				<span class="pointer" @click="showDataset(gse)">
					<b>[{{gse.species}}] - {{gse.name}} : <small><em>{{gse.description}}</em></small></b> 
				</span>
				<ul>
					<li v-for="data in gse.data">{{data.file}}</li>
				</ul>
				<div v-if="gse.show">
					<dataset-details from="dataset" :dataset-id="gse.dataset_id"></dataset-details>
				</div>
			</div>
		</div>
	</div>

</template>

<script>	
import { mapGetters } from 'vuex';
import DatasetDetails from '@/components/datasetDetails'


export default {
	name: 'Datasets',
	components:{DatasetDetails},
	data () {
		return {
			searchLabel:'symbol',
			search_gene:null,
			showNoResult:false,
			gene:null,
			geneNames:[],
			lists:[],
			loading:false,
			current_dataset:{},
			current_dataset_name:null,
			geneData:null,
			timeoutSearchSymbol:null,
			comparison_type:null,
			showPlot:false
		}
	},
	computed:{
		...mapGetters({
			currentUser: 'currentUser',
			datasets:'datasets'
		}),
	},
	methods:{
		showDataset(gse){
			let _this = this;
			_this.$set(gse,'show',!gse.show);
			// _this.$router.push("dataset/"+gse.dataset_id);
		},
	},
	mounted() {
		var _this = this;
		_this.$store.dispatch('getDatasets').catch(err => { _this.$snotify.error("Sorry an error occured: "+err) });
	}
}
</script>

// <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
	font-weight: normal;
}
a {
	color: #42b983;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
